<template>
  <div class="vld-parent">
    <Loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="true"
             :color="'#6BBFAF'"
             :width="128"
             :height="128"
             :loader="'spinner'">
    </Loading>
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    props: [
      'isLoading'
    ],
    components: {
      Loading
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/General/Loader.vue